import { FC } from 'react';

import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { storageApi } from '@/api';
import { StorageSystemForm } from '@/types/storageSystem';
import { isValidAssetName } from '@/utils';

type Props = {
  disabled?: boolean;
};

const Description: FC<Props> = ({ disabled = false }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <Form.Item
      wrapperCol={{ span: 12 }}
      className="p-16"
      style={{
        border: '0.5px solid',
        borderRadius: '10px',
        borderColor: theme.colors.grayLightAccent,
      }}
    >
      <Form.Item<StorageSystemForm>>
        <Form.Item<StorageSystemForm>
          wrapperCol={{ span: 24 }}
          name="name"
          hasFeedback
          validateDebounce={1000}
          label={t('storageSystem.form.name.label')}
          rules={[
            {
              required: true,
              message: t('storageSystem.form.name.requiredMessage'),
            },
            () => ({
              async validator(_rule, value) {
                if (isValidAssetName(value).valid) {
                  return new Promise<void>((resolve, reject) => {
                    storageApi
                      .searchStorageSystemByExactName(encodeURIComponent(value))
                      .then((response) => {
                        if (response.results?.length > 0) {
                          reject(
                            t('storageSystem.form.name.alreadyExistsMessage')
                          );
                        } else {
                          resolve();
                        }
                      })
                      .catch(() => resolve());
                  });
                } else
                  return new Promise((_resolve, reject) =>
                    reject(isValidAssetName(value).error)
                  );
              },
            }),
          ]}
        >
          <Input
            style={{ height: '34px' }}
            disabled={disabled}
            placeholder={t('storageSystem.form.name.placeholder')}
          />
        </Form.Item>
        <Form.Item<StorageSystemForm>
          wrapperCol={{ span: 24 }}
          name="description"
          label={t('storageSystem.form.description.label')}
          rules={[{ required: false }]}
        >
          <Input.TextArea
            disabled={disabled}
            style={{ resize: 'none' }}
            placeholder={t('storageSystem.form.description.placeholder')}
            rows={4}
            showCount
            maxLength={140}
          />
        </Form.Item>
      </Form.Item>
    </Form.Item>
  );
};

export default Description;
